import { removeAllLog } from './keypress'
import './keyboardRender'
import './micRecorder'

document.getElementById('resetAllLogButton')?.addEventListener('click', removeAllLog)
